import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";
import { makeArrayRandom } from "../../../../utils/learner";

export default function WebSelectTextImageLeft({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [availableChoices, setAvailableChoices] = useState(makeArrayRandom(data.choices));
    const [answer, setAnswer] = useState([]);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAvailableChoices(makeArrayRandom(data.choices));
        setAnswer([]);
    }, [question,
        data.choices,
    ]);

    const handleClickChoice = (choice) => {
        let ans = [...answer]
        if (answer.indexOf(choice.value) > -1) {
            removeChoice(choice.value);
        } else {
            if (!data.multiple) {
                ans = []; // reset for string
            }
    
            ans = [
                ...ans,
                choice.value
            ];
            
            setAnswer(ans);
            checkCanProceed(ans);
        }
    }

    const checkCanProceed = (ans) => {
        const canProceed = ans.length > 0;

        const finalAnswer = data.multiple ? ans : (ans[0] ?? "");

        onAnswer({
            canProceed,
            answer: finalAnswer,
        });
    }

    const removeChoice = (value) => {
        let newAnswer = [...answer];
        let index = newAnswer.indexOf(value)
        if (index !== -1) {
            newAnswer.splice(index, 1);
            setAnswer(newAnswer);
        }

        checkCanProceed(newAnswer);
    }

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "830px",
                textAlign: "center",
            }}
        >
            <Box component="img"
                src={`${imagesResources}${data.image}`}
                alt="Map Img"
            />

            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
            }}>
                {/* For Choices */}
                {availableChoices.map((choice, index) => (
                    <Box component="span" 
                        key={index}
                        sx={{
                            width: "240px",
                            height: "90px",
                            marginBottom: "10px",
                            display: "inline-table",
                            cursor: "pointer",
                            userSelect: "none",
                            backgroundColor: answer.includes(choice.value) ? "#afe23e" : "#dadada",
                            borderBottom: answer.includes(choice.value) ? "10px solid #639729" : "10px solid #808080",
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: "18px",
                        }}
                        onClick={() => {handleClickChoice(choice)}}
                    >
                        <Box component="span" 
                            sx={{
                                display: "table-cell",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                fontWeight: "bold",
                                textAlign: "center"
                            }}
                        >{choice.value}</Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};